module.exports = __webpack_public_path__ + "static/media/FASNYLogoProcess6.14e7c76c.jpg";